import api from "./axios";

export interface ClientDto {
  id: number;
  firstName: string;
  lastName: string;
  phone?: string;
  whatsappPhone?: string | null;
  email?: string;
  companyName?: string;
  tags?: string[];
  createdAt?: string;
  middleName?: string | null;
  iin?: string | null;
  idNumber?: string | null;
  idIssuer?: string | null;
  idIssueDate?: string | null;
  regAddress?: string | null;
}

export const getClients = () => api.get<ClientDto[]>("/clients");

export const getClient = (id: number) =>
  api.get<ClientDto>(`/clients/${id}`);

export const getClientDeals = (id: number) =>
  api.get(`/clients/${id}/deals`);

export const getClientTimeline = (dealId: number) =>
  api.get(`/deals/${dealId}/timeline`);

export const createClient = (data: Partial<ClientDto>) =>
  api.post("/clients", data);

export const updateClient = (id: number, data: Partial<ClientDto>) =>
  api.put(`/clients/${id}`, data);

export const deleteClient = (id: number) =>
  api.delete(`/clients/${id}`);